/*
**    iframe嵌入的路由
*/
export default [
    /** 平台售后管理 */
    {
      path: '/afterSaleManagement',
      name: 'afterSaleManagement',
      meta: {
        title: '售后管理',
        src:'/poprefundweb/afterSaleManagement/list'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    /** 平台售后管理详情 */
    {
      path: '/afterSaleManagementDetails',
      name: 'afterSaleManagementDetails',
      meta: {
        title: '售后管理详情',
        src:'/poprefundweb/afterSaleManagement/details'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
     /**新增补偿 */
     {
      path: '/createCompensate',
      name: 'createCompensate',
      meta: {
        title: '新增补偿',
        src:'/poprefundweb/createCompensate'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    /**补偿管理 */
    {
      path: '/compensate',
      name: 'compensate',
      meta: {
        title: '补偿管理',
        src:'/poprefundweb/compensate'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
      
    /**补偿管理详情 */
    {
      path: '/compensateDetail',
      name: 'compensateDetail',
      meta: {
        title: '补偿管理详情',
        src:'/poprefundweb/compensateDetail'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    // 新补偿管理
    {
      path: '/compensation',
      name: 'compensation',
      meta: {
        title: '补偿管理(新)',
        src:'/poprefundweb/compensation'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    {
      path: '/addCompensation',
      name: 'addCompensation',
      meta: {
        title: '新建补偿(新)',
        src:'/poprefundweb/addCompensation'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    {
      path: '/compensationDetail',
      name: 'compensationDetail',
      meta: {
        title: '补偿详情(新)',
        src:'/poprefundweb/compensationDetail'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    {
      path: '/complaint',
      name: 'complaint',
      meta: {
        title: '申诉管理',
        src:'/poprefundweb/complaint'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    {
      path: '/evaSystemList',
      name: 'evaSystemList',
      meta: {
        title: '评价管理',
        src:'/poprefundweb/evaSystem/list'
      },
      component: () =>
        import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
    },
    /** 平台活动报名管理 */
    {
      path: '/activityManagement',
      name: 'activityManagement',
      meta: {
        title: '营销活动报名',
        src:'/popActivity/activityList'
      },
      component: () =>
        import( /* webpackChunkName: "pop-activity" */ '../views/iframe/iframe.vue')
    },
    
  {
    path: '/marketingPlatform',
    name: 'marketingPlatform',
    meta: {
      title: '营销台',
      src:'/popMarketing/home'
    },
    component: () =>
      import( /* webpackChunkName: "pop-activity" */ '../views/iframe/iframe.vue')
  },
  {
    path: '/marketingPopFullCoupon',
    name: 'marketingPopFullCoupon',
    meta: {
      title: '营销台',
      src:'/popMarketing/popFullCoupon'
    },
    component: () =>
      import( /* webpackChunkName: "pop-activity" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/survey',
    name:'survey',
    meta: {
      title: '整体',
      src:'/biadmin/static/index.html#/survey',
      host:'bi.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "pop-survey" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/flow',
    name:'flow',
    meta: {
      title: '流量',
      src:'/biadmin/static/index.html#/flow',
      host:'bi.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "pop-flow" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/commodity',
    name:'commodity',
    meta: {
      title: '商品',
      src:'/biadmin/static/index.html#/commodity',
      host:'bi.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodity" */ '../views/iframe/iframe.vue')
  },{
    path:'/activityApplyList',
    name:'activityApplyList',
    meta: {
      title: '新营销活动报名',
      src:'/popmerchants/activityApplyList',
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodity" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/applyGoodsForMe',
    name:'applyGoodsForMe',
    meta: {
      title: '我的营销活动报名',
      src:'/popmerchants/applyGoodsForMe',
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodity" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/myTaskList',
    name:'myTaskList',
    meta: {
      title: '我的工单任务',
      src: `/popWeb/workOrderManagement/myTask/myTaskList`,
      host:'popxinyunadmin.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodity" */ '../views/iframe/iframe.vue')
  }, {
    path:'/policy',
    name:'policy',
    meta: {
      title: '极速售后',
      src: `/popWeb/policy`,
      host:'popxinyunadmin.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodity" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/allWorkOrderList',
    name:'allWorkOrderList',
    meta: {
      title: '全部工单',
      src: `/popWeb/workOrderManagement/allWorkOrder/allWorkOrderList`,
      host:'popxinyunadmin.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodity" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/allEventList',
    name:'allEventList',
    meta: {
      title: '全部事件单',
      src: `/popWeb/eventlist/list`,
      host:'popxinyunadmin.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodity" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/jiyitui',
    name:'jiyitui',
    meta: {
      title: '集易推',
      src: `jiyitui`
    },
    component: () =>
      import( /* webpackChunkName: "pop-jiyitui" */ '../views/iframe/iframe.vue')
  },
  {
    path:'/popforuserweb',
    name:'popforuserweb',
    meta: {
      title: '供应链金融助力计划',
      src: `popforuserweb`
    },
    component: () =>
      import( /* webpackChunkName: "pop-jiyitui" */ '../views/iframe/iframe.vue')
  },
  /**新补偿管理 */
  {
    path: '/compensation',
    name: 'compensation',
    meta: {
      title: '新补偿管理',
      src:'/poprefundweb/compensation'
    },
    component: () =>
      import( /* webpackChunkName: "pop-performance" */ '../views/iframe/iframe.vue')
  }, 
  {
    path:'/drawRecordToB',
    name:'drawRecordToB',
    meta: {
      title: '抽奖管理',
      src: '/pomsdiscover/drawRecordToB',
      host:'a.yunjiglobal.com'
    },
    component: () =>
      import( /* webpackChunkName: "drawRecordToB" */ '../views/iframe/iframe.vue')
  }
]